import ExcelOrdersModal from './ExcelOrdersModal.container'

export default ExcelOrdersModal
